export default __webpack_public_path__ + "static/media/slide17.291438eb.jpg";